import styled, { StyledComponent } from 'styled-components';
import { getTextStyles } from '../../theme/utils';
import { theme } from '../../theme';
import { AnchorProps, AnchorSize } from './types';

type StyledAnchorProps = {
  size: AnchorSize;
};

const sizeMappings: Record<StyledAnchorProps['size'], string> = {
  lg: theme.sizes.md,
  md: theme.sizes[5],
  base: theme.sizes.base,
  sm: theme.sizes[3],
};

const styleMappings: Record<StyledAnchorProps['size'], string> = {
  lg: 'linkLarge',
  md: 'linkMedium',
  base: 'link',
  sm: 'linkSmall',
};

export const UnstyledAnchor = styled.a<StyledAnchorProps>``;

// Standard variant styling
export const StandardAnchor = styled(UnstyledAnchor)<StyledAnchorProps>`
  display: inline-flex;
  align-items: center;

  cursor: pointer;
  transition: color 0.1s ease;
  text-decoration: none;
  padding: 0 2px;

  ${({ size }) => getTextStyles(theme.text[styleMappings[size]])};

  &:focus {
    outline: 0;
    border-color: ${theme.colors.secondary.blue.dark};
    border-radius: ${theme.radius.base};
    box-shadow: 0 0 0 2px ${theme.colors.secondary.blue.light};
  }

  &:hover {
    color: ${theme.colors.secondary.blue.dark};
  }

  svg {
    width: ${({ size }) => sizeMappings[size]};
    height: ${({ size }) => sizeMappings[size]};
    vertical-align: middle;
    flex-shrink: 0;
  }
`;

// Inherit font size and line height from parent
export const InheritAnchor = styled(StandardAnchor)<StyledAnchorProps>`
  font-size: inherit;
  line-height: inherit;
`;

export const AnchorMapping: Record<
  NonNullable<AnchorProps['variant']>,
  StyledComponent<'a', any, StyledAnchorProps>
> = {
  base: StandardAnchor,
  unstyled: UnstyledAnchor,
  inherit: InheritAnchor,
};
